<div class="chips-frame">
  <span><ng-content></ng-content></span>
  <span class="chips-frame-remove" (click)="removeEvent()">X</span>
</div>
